import React, { useEffect } from 'react';
import './QuestionStep/style/Q2.css'
export default function ThreeOptions({ option1, option2, option3, onOption1Press, onOption2Press, onOption3Press }) {

    useEffect(() => {
        var tmp = document.createElement("input");
        document.body.appendChild(tmp);
        tmp.focus();
        document.body.removeChild(tmp);
      }, []);

    return (
        <>
            <button className="allOptions firstOption" onClick={onOption1Press} type="button">{option1}</button>
            <button className="allOptions secondOption" onClick={onOption2Press} type="button">{option2}</button>
            <button className="allOptions thirdOption" onClick={onOption3Press} type="button">{option3}</button>
        </>
    )
}
